export default __webpack_public_path__ + "static/media/edit-v2.285c9b26.svg";